<div class="db-test-container p-xl">
  <h1 class="text-2xl font-semibold mb-lg">Database Smoke Test</h1>

  <p class="mb-lg">
    This test validates basic database functionality without requiring authentication or sync.
    It creates a simple table, inserts data, reads it back, and cleans up.
  </p>

  <div class="button-group flex gap-md mb-xl">
    <button class="btn btn-primary" (click)="runTest()" [disabled]="isRunning() || isResetting()" type="button">
      {{ isRunning() ? 'Running...' : 'Run Test' }}
    </button>

    <button class="btn btn-secondary" (click)="resetDatabase()" [disabled]="isRunning() || isResetting()" type="button">
      {{ isResetting() ? 'Resetting...' : 'Reset Database' }}
    </button>
  </div>

  @if (results().length > 0) {
  <div class="results-container">
    <h2 class="text-xl font-semibold mb-md">Test Results:</h2>

    <div class="results-list flex flex-column gap-md">
      @for (result of results(); track result.step) {
      <div class="result-item p-md" [class.result-success]="result.status === 'success'"
        [class.result-error]="result.status === 'error'">
        <div class="result-header flex gap-sm flex-align-center">
          <span class="status-icon">{{ getStatusIcon(result.status) }}</span>
          <span class="step-name font-semibold">{{ result.step }}</span>
        </div>

        @if (result.message) {
        <div class="result-message text-sm mt-sm">{{ result.message }}</div>
        }

        @if (result.error) {
        <div class="result-error text-sm mt-sm">
          <strong>Error:</strong> {{ result.error }}
        </div>
        }
      </div>
      }
    </div>
  </div>
  }
</div>